import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, errMsg } from "@/lib/api";
import { useLang, useT } from "@/lib/i18n";
import { useAutoTranslate } from "@/lib/useAutoTranslate";

export default function ExtranetLogin() {
  const nav = useNavigate();
  const t = useT();
  const { lang, setLang } = useLang();
  useAutoTranslate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/staff-auth/login", f);
      localStorage.setItem("staff_token", data.token);
      nav("/extranet");
    } catch (err) { toast.error(errMsg(err)); setBusy(false); }
  };
  return (
    <div className="extranet flex min-h-screen items-center justify-center bg-[#1C1917] px-4">
      <form onSubmit={submit} data-testid="extranet-login-form" className="fade-up w-full max-w-sm rounded-md bg-[#FAF7F2] p-8 shadow-2xl">
        <div className="flex items-center justify-between">
          <span className="font-ex-heading text-lg font-extrabold">Bedsolving Connect <span className="font-medium text-[#B4693E]">extranet</span></span>
          <button type="button" data-testid="login-lang-toggle" onClick={() => setLang(lang === "id" ? "en" : "id")} className="rounded border border-[#D6CCBE] px-2 py-0.5 text-xs font-bold">{lang === "id" ? "EN" : "ID"}</button>
        </div>
        <h1 className="mt-6 text-3xl font-extrabold">{t("Login Extranet")}</h1>
        <p className="text-sm text-slate-500">{t("Masuk untuk mengelola properti Anda.")}</p>
        <div className="mt-6 space-y-4">
          <div><Label htmlFor="sx-email">{t("Email")}</Label><Input id="sx-email" data-testid="staff-email-input" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-1.5" /></div>
          <div><Label htmlFor="sx-pass">{t("Kata sandi")}</Label><Input id="sx-pass" data-testid="staff-password-input" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="mt-1.5" /></div>
        </div>
        <button disabled={busy} data-testid="staff-login-button" className="mt-6 flex w-full items-center justify-center gap-2 rounded-sm bg-[#B4693E] py-3 font-semibold text-white transition-colors hover:bg-[#9A5530]">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}{t("Masuk")}
        </button>
      </form>
    </div>
  );
}
